import { calculateCurrencyMedians, getAllCurrencyValues } from '../helpers/currencyCalculations'

export type Currency = {
  id?: string
  name: string
  description?: string
  currencyDescription?: string
  purposeDescription?: string
  values: CurrencyValueWrapper[] | null
  usd?: number
  value?: number
}

export type CurrencyValueWrapper = {
  usd: number
  value: number
}

export type CurrencyBundle = Currency

export function getUnitPrice(currency: Currency) {
  // Handle format: usd and value directly on currency object
  if (currency.usd != null && currency.value != null && (!currency.values || currency.values.length === 0)) {
    return (currency.usd * 100) / (currency.value * 100)
  }

  // Handle format: values array
  if (!currency.values || currency.values.length === 0) {
    return 0
  }

  // If only one value, use it directly
  if (currency.values.length === 1) {
    return (currency.values[0].usd * 100) / (currency.values[0].value * 100)
  }

  // For multiple values, calculate median
  const allValues = getAllCurrencyValues(currency)
  const { medianUsd, medianGame, validValuesCount } = calculateCurrencyMedians(allValues)
  if (validValuesCount === 0) return 0

  return medianUsd / medianGame
}
